import type { DbEvent } from "shared/types/PostModel";
import { postsConfig } from "shared/types/PostModel";

import useDBEvents from "./useDBEvents";

const usePostsDBEvents = () => useDBEvents<DbEvent>(postsConfig.broadcastChannel);

export default usePostsDBEvents;
